module.exports = __webpack_public_path__ + "img/img_7.974569c6.svg";